/**
 * The refusals of `PUT products/{id}/variants/{variantId}/barcodes`, from
 * bos-api `ProductErrorCodes` (API-195). Each is a 400 that changes nothing;
 * a failed call answers with the `ErrorResponse`, whose `code` is one of
 * these. `BARCODE_TOO_LONG`, `BARCODE_DUPLICATE` and `BARCODE_TAKEN` name the
 * offending code in the message. An unknown product or variant is the 404
 * `PRODUCT_NOT_FOUND`, as for the product's other routes.
 */
export const PRODUCT_BARCODE_ERROR_CODES = [
    /** The main barcode is blank, or an alternate is. */
    'BARCODE_REQUIRED',
    /** A code is longer than 50 characters after trimming. */
    'BARCODE_TOO_LONG',
    /** A code is repeated, or an alternate equals the main, case-insensitively. */
    'BARCODE_DUPLICATE',
    /** The main barcode's regenerated unique key is already another variant's. */
    'BARCODE_TAKEN',
] as const;

export type ProductBarcodeErrorCode =
    (typeof PRODUCT_BARCODE_ERROR_CODES)[number];

export const isProductBarcodeErrorCode = (
    raw: unknown,
): raw is ProductBarcodeErrorCode =>
    typeof raw === 'string' &&
    (PRODUCT_BARCODE_ERROR_CODES as readonly string[]).includes(raw);
